import { Head, usePage, useForm, Link } from '@inertiajs/react';
import MainLayout from '@/Layouts/MainLayout';
import BlogHeader from './Partials/BlogHeader';
import Avatar from '@/Components/Avatar';
import parse from 'html-react-parser';
import AdvertCard from '@/Components/Cards/AdvertCard';

const Show = () => {
	const { blog, ad } = usePage().props;
	const { title, content, user } = blog;

	return (
		<>
			<Head title={`${title}`} />

			<BlogHeader />

			<div className="container mx-auto flex flex-wrap px-4 my-8 min-h-[500px]">
				<div className="w-full max-w-4xl mx-auto">
					<div className="w-full no-tailwindcss-base lg:w-3/4">{parse(content)}</div>

					<div className="divider my-8"></div>
					{user && !user.deletedAt ? (
						<Link href={route('profile.show', user)} className="flex gap-4 w-full">
							<Avatar url={user.avatar} country={user.country} />
							<div>
								<h2>{user.first_name + ' ' + user.last_name}</h2>
								<div>@{user.username}</div>
							</div>
						</Link>
					) : (
						<div className="flex gap-4 w-full">
							<Avatar url={user.avatar} country={user.country} />
							<div>
								<h2>{user.first_name + ' ' + user.last_name}</h2>
								<div>@{user.username}</div>
							</div>
						</div>
					)}
				</div>
				<div className="w-1/4">
					{ad && (
						<AdvertCard
							advert={ad}
						/>
					)}
				</div>
			</div>
		</>
	);
};

Show.layout = (page) => <MainLayout children={page} />;

export default Show;
